var isJsonString = function (str) {
    try {
        JSON.parse(str);
    }
    catch (e) {
        return false;
    }
    return true;
};
var isBrowser = function () { return typeof window !== 'undefined'; };

var isAvailable = function () {
    return navigator.cookieEnabled;
};
/**
 * Get a cookie.
 * @param key The name of the cookie to get (string).
 * @returns  Returns a value of a cookie.
 */
var getItem = function (key) {
    if (!key || !isBrowser()) {
        return null;
    }
    return (decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' +
        encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') +
        '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null);
};
var setItem = function (key, value, options) {
    var _a = options || {}, _b = _a.end, end = _b === void 0 ? undefined : _b, _c = _a.path, path = _c === void 0 ? undefined : _c, _d = _a.domain, domain = _d === void 0 ? undefined : _d, _e = _a.secure, secure = _e === void 0 ? undefined : _e, _f = _a.httpOnly, httpOnly = _f === void 0 ? undefined : _f;
    var expires = '';
    if (!key || /^(?:expires|max\-age|path|domain|secure)$/i.test(key)) {
        return false;
    }
    if (end) {
        // tslint:disable-next-line:switch-default
        switch (end.constructor) {
            case Number:
                expires = end === Infinity ? '; Expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + end;
                /*
                Note: Despite officially defined in RFC 6265, the use of `max-age` is not compatible with any
                version of Internet Explorer, Edge and some mobile browsers. Therefore passing a number to
                the end parameter might not work as expected. A possible solution might be to convert the the
                relative time to an absolute time. For instance, replacing the previous line with:
                */
                /*
                expires = end === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; expires=" + (new Date(end * 1e3 + Date.now())).toUTCString();
                */
                break;
            case String:
                expires = '; expires=' + end;
                break;
            case Date:
                expires = '; expires=' + end.toUTCString();
                break;
        }
    }
    document.cookie =
        encodeURIComponent(key) +
            '=' +
            encodeURIComponent(value) +
            expires +
            (domain ? '; domain=' + domain : '') +
            (path ? '; path=' + path : '') +
            (secure ? '; secure' : '') +
            (httpOnly ? '; httpOnly' : '');
    return true;
};
var hasItem = function (key) {
    if (!key || /^(?:expires|max\-age|path|domain|secure|httpOnly)$/i.test(key)) {
        return false;
    }
    return new RegExp('(?:^|;\\s*)' + encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=').test(document.cookie);
};
var removeItem = function (key, options) {
    var _a = options || {}, _b = _a.path, path = _b === void 0 ? undefined : _b, _c = _a.domain, domain = _c === void 0 ? undefined : _c;
    if (!hasItem(key)) {
        return false;
    }
    document.cookie = encodeURIComponent(key) + "=; Expires=Thu, 01 Jan 1970 00:00:01 GMT" + (domain ? '; Domain=' + domain : '') + (path ? '; Path=' + path : '');
    return true;
};
var getKeys = function () {
    var returnedKeys = [];
    var keys = document.cookie
        .replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, '')
        .split(/\s*(?:\=[^;]*)?;\s*/);
    keys.filter(function (key) { return key !== ''; }).forEach(function (key) {
        returnedKeys.push(decodeURIComponent(key));
    });
    return returnedKeys;
};
var clear = function (path, domain) {
    var keys = getKeys();
    keys.forEach(function (key) {
        removeItem(key, { path: path, domain: domain });
    });
};
var cookies = {
    isAvailable: isAvailable,
    getItem: getItem,
    setItem: setItem,
    hasItem: hasItem,
    removeItem: removeItem,
    getKeys: getKeys,
    clear: clear,
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var dispatch = function (name, data) {
    var event = new CustomEvent("ysAnalytics/" + name, __assign({ bubbles: true }, (data && { detail: data })));
    document.dispatchEvent(event);
};
var on = function (selector, eventNames, handler, options) {
    var _a = options || {}, _b = _a.context, context = _b === void 0 ? undefined : _b, _c = _a.useCapture, useCapture = _c === void 0 ? false : _c;
    var rootElement = context ? (document.querySelector(context) || document) : document;
    var eventArray = [];
    if (typeof eventNames === 'string') {
        eventArray.push(eventNames);
    }
    else {
        eventArray = eventNames.slice();
    }
    if (rootElement) {
        eventArray.map(function (eventName) {
            rootElement.addEventListener(eventName, function (event) {
                var target = event.target || event.srcElement;
                if (!target || (!target.matches(selector) && !target.closest(selector))) {
                    return;
                }
                handler(event);
            }, useCapture);
        });
    }
};
var events = {
    dispatch: dispatch,
    on: on,
};

var init = function () {
    window.dataLayer = window.dataLayer || [];
};
var reset = function () {
    if (typeof window !== 'undefined' && window.dataLayer) {
        window.dataLayer.push({ ecommerce: null });
    }
};
var push = function (layerObject, config) {
    init();
    var data = {};
    var _a = config || {}, _b = _a.event, event = _b === void 0 ? undefined : _b, _c = _a.timeout, timeout = _c === void 0 ? undefined : _c, _d = _a.category, category = _d === void 0 ? undefined : _d;
    if (layerObject) {
        data = layerObject;
    }
    return new Promise(function (resolve) {
        if (event) {
            data.event = event;
            if (timeout) {
                data.eventTimeout = timeout;
            }
            if (category) {
                data.eventCategory = category;
            }
            dispatch(event, data);
            data.eventCallback = function (containerId) {
                resolve({
                    event: true,
                    containerId: containerId,
                    data: data,
                });
            };
            // @ts-ignore
            window.dataLayer.push(data || {});
        }
        else {
            // @ts-ignore
            window.dataLayer.push(data || {});
            resolve({
                event: false,
                data: data,
            });
        }
    });
};
var getDataModel = function (id) {
    if (!window.google_tag_manager || !window.google_tag_manager[id]) {
        return null;
    }
    var model = window.google_tag_manager[id].dataLayer.get({
        split: function () { return []; },
    });
    return model || {};
};
var dataLayer = {
    init: init,
    push: push,
    reset: reset,
    getDataModel: getDataModel,
};

var DataLayerEvents = {
    PRODUCT_IMPRESSIONS: {
        event: 'productImpressions',
        label: 'impressions',
    },
    PRODUCT_CLICK: {
        event: 'productClick',
        label: 'click',
    },
    PRODUCT_DETAIL_IMPRESSIONS: {
        event: 'productDetailImpressions',
        label: 'detail',
    },
    ADD_TO_CART: {
        event: 'addToCart',
        label: 'add',
    },
    REMOVE_FROM_CART: {
        event: 'removeFromCart',
        label: 'remove',
    },
    PROMOTION_VIEW: {
        event: 'promotionView',
        label: 'promoView',
    },
    PROMOTION_CLICK: {
        event: 'promotionClick',
        label: 'promoClick',
    },
    CHECKOUT: {
        event: 'checkout',
        label: 'checkout',
    },
    CHECKOUT_OPTION: {
        event: 'checkoutOption',
        label: 'checkout_option',
    },
    PURCHASE: {
        event: 'purchase',
        label: 'purchase',
    },
    REFUND: {
        event: 'refund',
        label: 'refund',
    },
    // GA4
    GA4_VIEW_ITEM_LIST: {
        event: 'ga4_view_item_list',
        label: 'ga4_view_item_list'
    },
    GA4_SELECT_ITEM: {
        event: 'ga4_select_item',
        label: 'ga4_select_item',
    },
    GA4_VIEW_ITEM: {
        event: 'ga4_view_item',
        label: 'ga4_view_item',
    },
    GA4_ADD_TO_CART: {
        event: 'ga4_add_to_cart',
        label: 'ga4_add_to_cart',
    },
    GA4_REMOVE_FROM_CART: {
        event: 'ga4_remove_from_cart',
        label: 'ga4_remove_from_cart',
    },
    BEGIN_CHECKOUT: {
        event: 'ga4_begin_checkout',
        label: 'ga4_begin_checkout',
    },
    GA4_PURCHASE: {
        event: 'ga4_purchase',
        label: 'ga4_purchase',
    },
};
var addEcommerceObject = function (name, ecommerceObj, noLabel) {
    var _a;
    reset();
    // @ts-ignore
    var currencyCode = ecommerceObj.currencyCode, customerData = ecommerceObj.customerData, rest = __rest(ecommerceObj, ["currencyCode", "customerData"]);
    return {
        ecommerce: __assign({}, (currencyCode && { currencyCode: currencyCode }), (customerData && { customerData: customerData }), (noLabel ? rest : (_a = {}, _a[name] = rest, _a))
        // [name]: rest,
        ),
    };
};
var pushEcommerceObject = function (ecommerceObj, eventObject, config) {
    var _a = config || {}, _b = _a.event, event = _b === void 0 ? eventObject.event : _b, _c = _a.timeout, timeout = _c === void 0 ? undefined : _c, _d = _a.noLabel, noLabel = _d === void 0 ? false : _d;
    return push(addEcommerceObject(eventObject.label, ecommerceObj, noLabel), {
        event: event,
        timeout: timeout,
    });
};
// ga4
var ga4ProductList = function (ecommerceObj, config) {
    return pushEcommerceObject(ecommerceObj, DataLayerEvents.GA4_VIEW_ITEM_LIST, config);
};
var ga4Product = function (ecommerceObj, config) {
    return pushEcommerceObject(ecommerceObj, DataLayerEvents.GA4_VIEW_ITEM, config);
};
var ga4ProductClick = function (ecommerceObj, config) { return pushEcommerceObject(ecommerceObj, DataLayerEvents.GA4_SELECT_ITEM, config); };
var ga4Checkout = function (ecommerceObj, config) {
    return pushEcommerceObject(ecommerceObj, DataLayerEvents.BEGIN_CHECKOUT, config);
};
var ga4addProductToCart = function (ecommerceObj, config) { return pushEcommerceObject(ecommerceObj, DataLayerEvents.GA4_ADD_TO_CART, config); };
var ga4removeProductFromCart = function (ecommerceObj, config) { return pushEcommerceObject(ecommerceObj, DataLayerEvents.GA4_REMOVE_FROM_CART, config); };
var ga4purchase = function (ecommerceObj, config) {
    return pushEcommerceObject(ecommerceObj.actionField, DataLayerEvents.GA4_PURCHASE, config);
};
// UA
var productImpressions = function (ecommerceObj, config) {
    return pushEcommerceObject(ecommerceObj, DataLayerEvents.PRODUCT_IMPRESSIONS, config);
};
var productDetailImpressions = function (ecommerceObj, config) {
    return pushEcommerceObject(ecommerceObj, DataLayerEvents.PRODUCT_DETAIL_IMPRESSIONS, config);
};
var productClick = function (ecommerceObj, config) { return pushEcommerceObject(ecommerceObj, DataLayerEvents.PRODUCT_CLICK, config); };
var addProductToCart = function (ecommerceObj, config) { return pushEcommerceObject(ecommerceObj, DataLayerEvents.ADD_TO_CART, config); };
var removeProductFromCart = function (ecommerceObj, config) {
    return pushEcommerceObject(ecommerceObj, DataLayerEvents.REMOVE_FROM_CART, config);
};
var promotionImpressions = function (ecommerceObj, config) {
    return pushEcommerceObject(ecommerceObj, DataLayerEvents.PROMOTION_VIEW, config);
};
var promotionClick = function (ecommerceObj, config) {
    return pushEcommerceObject(ecommerceObj, DataLayerEvents.PROMOTION_CLICK, config);
};
var checkout = function (ecommerceObj, config) {
    return pushEcommerceObject(ecommerceObj, DataLayerEvents.CHECKOUT, config);
};
var checkoutOption = function (ecommerceObj, config) {
    return pushEcommerceObject(ecommerceObj, DataLayerEvents.CHECKOUT_OPTION, config);
};
var purchase = function (ecommerceObj, config) {
    return pushEcommerceObject(ecommerceObj, DataLayerEvents.PURCHASE, config);
};
var refund = function (ecommerceObj, config) {
    return pushEcommerceObject(ecommerceObj, DataLayerEvents.REFUND, config);
};
var ecommerce = {
    productImpressions: productImpressions,
    productDetailImpressions: productDetailImpressions,
    productClick: productClick,
    addProductToCart: addProductToCart,
    removeProductFromCart: removeProductFromCart,
    promotionImpressions: promotionImpressions,
    promotionClick: promotionClick,
    checkout: checkout,
    checkoutOption: checkoutOption,
    purchase: purchase,
    refund: refund,
    ga4Checkout: ga4Checkout,
    ga4ProductList: ga4ProductList,
    ga4Product: ga4Product,
    ga4ProductClick: ga4ProductClick
};

var isAvailable$1 = function () {
    if (typeof localStorage === 'object') {
        try {
            localStorage.setItem('localStorage', 'enabled');
            localStorage.removeItem('localStorage');
            return true;
        }
        catch (e) {
            return false;
        }
    }
    return false;
};
var getItem$1 = function (key) {
    return isAvailable$1() ? localStorage.getItem(key) : null;
};
var setItem$1 = function (key, value) {
    if (isAvailable$1()) {
        localStorage.setItem(key, value);
    }
};
var hasItem$1 = function (key) {
    if (isAvailable$1()) {
        return localStorage.getItem(key) ? true : false;
    }
    return false;
};
var removeItem$1 = function (key) {
    if (isAvailable$1()) {
        localStorage.removeItem(key);
    }
};
var getKeys$1 = function () {
    if (isAvailable$1()) {
        return Object.keys(localStorage);
    }
    return [];
};
var clear$1 = function () {
    if (isAvailable$1()) {
        localStorage.clear();
    }
};
var storage = {
    isAvailable: isAvailable$1,
    getItem: getItem$1,
    setItem: setItem$1,
    hasItem: hasItem$1,
    removeItem: removeItem$1,
    getKeys: getKeys$1,
    clear: clear$1,
};

var isAvailable$2 = function () { return !!window.google_tag_manager; };
var init$1 = function (containerId, config) {
    var _a = config || {}, _b = _a.layerName, layerName = _b === void 0 ? 'dataLayer' : _b, _c = _a.async, async = _c === void 0 ? true : _c;
    var layerObject = {
        'gtm.start': new Date().getTime(),
    };
    dataLayer.init();
    dataLayer.push(layerObject, {
        event: 'gtm.js',
    });
    return new Promise(function (resolve, reject) {
        var dataLayerName = layerName !== 'dataLayer' ? "&dataLayer=" + layerName : '';
        var firstScript = document.getElementsByTagName('script')[0];
        var newScript = document.createElement('script');
        try {
            newScript.async = async;
            newScript.onload = function () {
                var loadGTMEvent = new CustomEvent('ysAnalytics/loadGTM', {
                    bubbles: true,
                });
                document.dispatchEvent(loadGTMEvent);
                resolve(newScript);
            };
            newScript.onerror = function (error) {
                reject(error);
            };
            newScript.src = "https://www.googletagmanager.com/gtm.js?id=" + containerId + dataLayerName;
            if (firstScript && firstScript.parentNode) {
                firstScript.parentNode.insertBefore(newScript, firstScript);
            }
            else {
                document.body.insertBefore(newScript, document.body.firstChild);
            }
        }
        catch (error) {
            reject(error);
        }
    });
};
var gtm = {
    isAvailable: isAvailable$2,
    init: init$1,
};

var DataSelectors = {
    LAYER_DATA: 'data-analytics',
};
var LayerDataTypes = {
    PRODUCT: {
        selector: 'product-detail',
        entity: 'Product',
    },
    PRODUCT_LIST: {
        selector: 'product-list',
        entity: 'ItemList',
    },
    ORDER: {
        selector: 'order',
        entity: 'Order',
    }
};
var getFromLayerData = function (name, context) {
    var selector = context || document;
    var layerData = selector.querySelector("script[" + DataSelectors.LAYER_DATA + "=\"" + name + "\"]");
    if (layerData && layerData.innerText && isJsonString(layerData.innerText)) {
        var parsedData = JSON.parse(layerData.innerText);
        return parsedData || null;
    }
    return null;
};
var getFromLayerDataAll = function (name, context) {
    var selector = context || document;
    var layerDataAll = selector.querySelectorAll("script[" + DataSelectors.LAYER_DATA + "=\"" + name + "\"]");
    var parsedDataAll = [];
    Array.from(layerDataAll).map(function (layerData) {
        if (layerData && layerData.innerText && isJsonString(layerData.innerText)) {
            var parsedData = JSON.parse(layerData.innerText);
            parsedDataAll.push(parsedData);
        }
    });
    return parsedDataAll;
};
var getProductList = function (context) {
    return getFromLayerData(LayerDataTypes.PRODUCT_LIST.selector, context);
};
var getProductListAll = function (context) {
    return getFromLayerDataAll(LayerDataTypes.PRODUCT_LIST.selector, context);
};
var getProduct = function (context) {
    return getFromLayerData(LayerDataTypes.PRODUCT.selector, context);
};
var getProductFromList = function (context) {
    return getFromLayerData(LayerDataTypes.PRODUCT.selector, context);
};
var getOrder = function (context) {
    return getFromLayerData(LayerDataTypes.ORDER.selector, context);
};
var dom = {
    getProduct: getProduct,
    getProductList: getProductList,
    getProductListAll: getProductListAll,
    getProductFromList: getProductFromList,
    getOrder: getOrder
};

var waitForFindify = function () {
    return new Promise(function (resolve) {
        (window.findifyCallbacks = window.findifyCallbacks || []).push(function (findify) { return resolve(findify); });
    });
};

var _this = undefined;
var emptyPromise = function () { return Promise.resolve({ error: 'Finfify Analytics not initialized or no findify data detected' }); };
// Click suggestion event - what data should it take? when should it trigger?
var findifyClickSuggestion = function (rid, suggestion) { return __awaiter(_this, void 0, void 0, function () {
    var findifyInstance;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, waitForFindify()];
            case 1:
                findifyInstance = _a.sent();
                return [2 /*return*/, findifyInstance.analytics.sendEvent('click-suggestion', {
                        rid: rid,
                        suggestion: suggestion
                    })];
        }
    });
}); };
// Click item event
var findifyClickItem = function (itemId, rid) { return __awaiter(_this, void 0, void 0, function () {
    var findifyInstance;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, waitForFindify()];
            case 1:
                findifyInstance = _a.sent();
                return [2 /*return*/, rid ? findifyInstance.analytics.sendEvent('click-item', {
                        rid: rid,
                        item_id: itemId,
                    }) : findifyInstance.analytics.sendEvent('click-item', { item_id: itemId })];
        }
    });
}); };
// Redirect event - what data should it take? when should it trigger?
var findifyRedirect = function (rid, suggestion) { return __awaiter(_this, void 0, void 0, function () {
    var findifyInstance;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, waitForFindify()];
            case 1:
                findifyInstance = _a.sent();
                return [2 /*return*/, findifyInstance.analytics.sendEvent('redirect', {
                        rid: rid,
                        suggestion: suggestion
                    })];
        }
    });
}); };
// Purchase event
var findifyPurchase = function (orderData, idType) { return __awaiter(_this, void 0, void 0, function () {
    var findifyInstance, order, totals, currency, items;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, waitForFindify()];
            case 1:
                findifyInstance = _a.sent();
                order = orderData.order, totals = orderData.totals, currency = orderData.currency, items = orderData.items;
                return [2 /*return*/, findifyInstance.analytics.sendEvent('purchase', {
                        order_id: order,
                        currency: currency,
                        revenue: totals.grandTotalPriceAsNumber,
                        line_items: getFindifyItems(items, idType),
                    })];
        }
    });
}); };
var getFindifyItems = function (items, idType) {
    var cartItems = [];
    items.map(function (item) {
        cartItems.push(getFindifyCartProduct(item, idType));
    });
    return cartItems;
};
var getFindifyCartProduct = function (item, idType, priceIncluded, rid) {
    if (priceIncluded === void 0) { priceIncluded = true; }
    var id = idType === 'id' && item ? item.product.product : item ? item.sku : '';
    if (priceIncluded && rid) {
        return {
            quantity: item.quantity,
            item_id: id,
            unit_price: item.priceEachAsNumber,
            rid: rid,
        };
    }
    else if (priceIncluded && !rid) {
        return {
            quantity: item.quantity,
            item_id: id,
            unit_price: item.priceEachAsNumber,
        };
    }
    else if (!priceIncluded && rid) {
        return {
            quantity: item.quantity,
            item_id: id,
            rid: rid,
        };
    }
    else {
        return {
            quantity: item.quantity,
            item_id: id,
        };
    }
};
// Update cart event
var findifyUpdateCart = function (newStateItems, idType) { return __awaiter(_this, void 0, void 0, function () {
    var findifyInstance, lineItems;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, waitForFindify()];
            case 1:
                findifyInstance = _a.sent();
                lineItems = [];
                newStateItems.map(function (item) {
                    lineItems.push(getFindifyCartProduct(item, idType));
                });
                return [2 /*return*/, lineItems ? findifyInstance.analytics.sendEvent('update-cart', {
                        line_items: lineItems
                    }) : emptyPromise()];
        }
    });
}); };
// Add to cart event
var findifyAddToCart = function (newStateItems, oldStateItems, idType, rid) { return __awaiter(_this, void 0, void 0, function () {
    var findifyInstance, itemsDiff;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, waitForFindify()];
            case 1:
                findifyInstance = _a.sent();
                itemsDiff = getCartItemsDiff(newStateItems, oldStateItems || []);
                if (itemsDiff.length > 0) {
                    itemsDiff.map(function (item) {
                        return findifyInstance.analytics.sendEvent('add-to-cart', getFindifyCartProduct(item, idType, false, rid));
                    });
                }
                else {
                    return [2 /*return*/, emptyPromise()];
                }
                return [2 /*return*/];
        }
    });
}); };
// View page event
var findifyViewPage = function (context, idType) { return __awaiter(_this, void 0, void 0, function () {
    var findifyInstance, product, id;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, waitForFindify()];
            case 1:
                findifyInstance = _a.sent();
                product = getProduct(context);
                id = idType && idType === 'id' && product ? product.productID : product ? product.sku : '';
                return [2 /*return*/, product
                        ? findifyInstance.analytics.sendEvent('view-page', {
                            item_id: id,
                        })
                        : findifyInstance.analytics.sendEvent('view-page')];
        }
    });
}); };
var findify = {
    findifyClickSuggestion: findifyClickSuggestion,
    findifyClickItem: findifyClickItem,
    findifyRedirect: findifyRedirect,
    findifyPurchase: findifyPurchase,
    findifyUpdateCart: findifyUpdateCart,
    findifyAddToCart: findifyAddToCart,
    findifyViewPage: findifyViewPage,
    waitForFindify: waitForFindify
};

var isAvailable$3 = function () { return !!window.fbq; };
var init$2 = function (config) {
    var _a = config || {}, _b = _a.containerId, containerId = _b === void 0 ? undefined : _b, _c = _a.async, async = _c === void 0 ? true : _c, _d = _a.loaded, loaded = _d === void 0 ? true : _d;
    return new Promise(function (resolve, reject) {
        if (window.fbq) {
            resolve({
                message: 'Already inited',
            });
        }
        var n = window.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!window._fbq) {
            window._fbq = n;
        }
        n.push = n;
        n.loaded = loaded;
        n.version = '2.0';
        n.queue = [];
        var firstScript = document.getElementsByTagName('script')[0];
        var newScript = document.createElement('script');
        try {
            newScript.async = async;
            newScript.src = 'https://connect.facebook.net/en_US/fbevents.js';
            newScript.onload = function () {
                if (containerId) {
                    trackInit(containerId);
                }
                var layerObject = {
                    'fbevents.start': new Date().getTime(),
                };
                dataLayer.init();
                dataLayer.push(layerObject, {
                    event: 'fbevents.js',
                });
                var loadFacebookEvent = new CustomEvent('ysAnalytics/loadFacebook', {
                    bubbles: true,
                });
                document.dispatchEvent(loadFacebookEvent);
                resolve(newScript);
            };
            newScript.onerror = function (error) {
                reject(error);
            };
            if (firstScript && firstScript.parentNode) {
                firstScript.parentNode.insertBefore(newScript, firstScript);
            }
            else {
                document.body.insertBefore(newScript, document.body.firstChild);
            }
        }
        catch (error) {
            reject(error);
        }
    });
};
var push$1 = function (event, name, config) {
    if (!isAvailable$3()) {
        init$2();
    }
    return new Promise(function (resolve, reject) {
        if (window.fbq) {
            try {
                if (config) {
                    // @ts-ignore
                    window.fbq(event, name, config);
                }
                else {
                    // @ts-ignore
                    window.fbq(event, name);
                }
                dispatch(name, config && config);
                resolve({
                    event: false,
                    data: __assign({ event: event,
                        name: name }, (config && { data: config })),
                });
            }
            catch (error) {
                reject(error);
            }
        }
        else {
            resolve({
                message: 'No FB script',
            });
        }
    });
};
var trackInit = function (containerId) { return push$1('init', containerId); };
var track = function (name, config) { return push$1('track', name, config); };
var trackCustom = function (name, config) { return push$1('trackCustom', name, config); };
var onload = function (callback) {
    if (isAvailable$3()) {
        // loaded before the call
        callback();
    }
    else {
        // loaded after the call
        document.addEventListener('ysAnalytics/loadFacebook', callback, false);
    }
};
var facebook = {
    isAvailable: isAvailable$3,
    init: init$2,
    push: push$1,
    onload: onload,
    trackInit: trackInit,
    track: track,
    trackCustom: trackCustom,
};

var checkoutSteps = {
    COUNTRY_LOAD: {
        value: 1,
        label: 'Country Load',
    },
    PAYMENT_LOAD: {
        value: 2,
        label: 'Payment Load',
    },
    SHIPPING_LOAD: {
        value: 3,
        label: 'Shipping Load',
    },
    ADDRESS_FIELDS_LOAD: {
        value: 4,
        label: 'Address Fields Load',
    },
    SHIPWALLET_LOAD: {
        value: 5,
        label: 'Shipwallet Load',
    },
    KLARNA_LOAD: {
        value: 6,
        label: 'Klarna Load',
    },
    LOGGED_USER_LOAD: {
        value: 7,
        label: 'Looged User Load',
    },
    LOGIN_SUCCESS: {
        value: 8,
        label: 'Login Success',
    },
    COUNTRY_CHANGE: {
        value: 9,
        label: 'Country Change',
    },
    PAYMENT_CHANGE: {
        value: 10,
        label: 'Payment Change',
    },
    SHIPPING_CHANGE: {
        value: 11,
        label: 'Shipping Change',
    },
    ADDRESS_VALID: {
        value: 12,
        label: 'Valid Address',
    },
    TERMS_CHANGE: {
        value: 13,
        label: 'Terms Change',
    },
    KLARNA_FILLED: {
        value: 14,
        label: 'Klarna Filled',
    },
    PLACED_ORDER: {
        value: 15,
        label: 'Place Order',
    },
};
// helper functions
var loaded = function (value) { return (value ? 'TRUE' : 'FALSE'); };
var getItemCategory = function (item) {
    var productUrl = item.productUrl;
    var category = '';
    if (productUrl && productUrl.length > 0) {
        var prodUrlArray = productUrl.split('/');
        prodUrlArray.splice(0, 4);
        prodUrlArray.splice(-1, 1);
        category = prodUrlArray.join('/');
    }
    return category;
};
var grabCategoriesCollection = function (categories) {
    var uniqueCategories = new Set();
    for (var i = 0; i < categories.length; i++) {
        var category = categories[i].name;
        for (var j = 0; j < category.length; j++) {
            uniqueCategories.add(category[j]);
            if (uniqueCategories.size === 5) {
                break;
            }
        }
        if (uniqueCategories.size === 5) {
            break;
        }
    }
    return processCategories(Array.from(uniqueCategories));
};
var processCategories = function (categories) { return ({
    item_category: categories[0] || '',
    item_category2: categories[1] || '',
    item_category3: categories[2] || '',
    item_category4: categories[3] || '',
    item_category5: categories[4] || ''
}); };
var eeCheckoutSteps = {
    countryLoad: function (value, currency) { return eeCheckoutStep(checkoutSteps.COUNTRY_LOAD, value, currency); },
    paymentLoad: function (value, currency) { return eeCheckoutStep(checkoutSteps.PAYMENT_LOAD, value, currency); },
    shippingLoad: function (value, currency) { return eeCheckoutStep(checkoutSteps.SHIPPING_LOAD, value, currency); },
    addressFieldsLoad: function (currency) { return eeCheckoutStep(checkoutSteps.ADDRESS_FIELDS_LOAD, loaded(true), currency); },
    shipwalletLoad: function (currency) { return eeCheckoutStep(checkoutSteps.SHIPWALLET_LOAD, loaded(true), currency); },
    klarnaLoad: function (currency) { return eeCheckoutStep(checkoutSteps.KLARNA_LOAD, loaded(true), currency); },
    loggedUserLoad: function (currency) { return eeCheckoutStep(checkoutSteps.LOGGED_USER_LOAD, loaded(true), currency); },
    loginSuccess: function (currency) { return eeCheckoutStep(checkoutSteps.LOGIN_SUCCESS, loaded(true), currency); },
    countryChange: function (value, currency) { return eeCheckoutStep(checkoutSteps.COUNTRY_CHANGE, value, currency); },
    paymentChange: function (value, currency) { return eeCheckoutStep(checkoutSteps.PAYMENT_CHANGE, value, currency); },
    shippingChange: function (value, currency) { return eeCheckoutStep(checkoutSteps.SHIPPING_CHANGE, value, currency); },
    addressValid: function (currency) { return eeCheckoutStep(checkoutSteps.ADDRESS_VALID, loaded(true), currency); },
    termsChange: function (value, currency) { return eeCheckoutStep(checkoutSteps.TERMS_CHANGE, loaded(value), currency); },
    klarnaFilled: function (currency) { return eeCheckoutStep(checkoutSteps.KLARNA_FILLED, loaded(true), currency); },
    placedOrder: function (currency) { return eeCheckoutStep(checkoutSteps.PLACED_ORDER, loaded(true), currency); },
};
var getCartItemsDiff = function (payloadItems, stateItems) {
    var result = [];
    // Get the array that is the difference of elements based on the comparison with the stateItems array
    // Detect if new product added
    var newFilteredItemsState = payloadItems.filter(function (payloadItem) {
        return !stateItems.some(function (stateItem) {
            return payloadItem.item === stateItem.item && payloadItem.quantity === stateItem.quantity;
        });
    });
    // Get the array that is the difference of elements based on the comparison with the payloadItems array
    // Detect if removed product
    var oldFilteredItemsState = stateItems.filter(function (stateItem) {
        return !payloadItems.some(function (payloadItem) {
            return stateItem.item === payloadItem.item && stateItem.quantity === payloadItem.quantity;
        });
    });
    // If not added new product
    if (newFilteredItemsState.length === 0) {
        result = oldFilteredItemsState;
        // If not removed product
    }
    else if (oldFilteredItemsState.length === 0) {
        result = newFilteredItemsState;
        // If only quantity is the difference (products array length has not been changed)
    }
    else if (newFilteredItemsState.length === oldFilteredItemsState.length) {
        result = newFilteredItemsState.map(function (item, index) { return (__assign({}, item, { quantity: Math.abs(oldFilteredItemsState[index].quantity - item.quantity) })); });
    }
    return result;
};
var getEECustomerData = function (address) {
    return {
        address1: address.address1,
        address2: address.address2,
        city: address.city,
        country: address.countryName,
        countryCode: address.country,
        email: address.email,
        firstName: address.firstName,
        lastName: address.lastName,
        phone: address.phoneNumber,
        state: address.state,
        zipCode: address.zipCode
    };
};
var getEECartProducts = function (item) {
    return __assign({ id: item.product.sku, name: item.product.name, price: "" + item.priceEachBeforeDiscountAsNumber, priceReduction: "" + item.priceEachReductionAsNumber, brand: item.product.brandName, category: getItemCategory(item), variant: item.product.variantName, quantity: "" + item.quantity }, (item.product.centraProduct && { centraProduct: "" + item.product.centraProduct }), (item.product.centraVariant && { centraVariant: "" + item.product.centraVariant }), (window.getContentId && { content_id: window.getContentId(item.product) }));
};
var getEECartItems = function (items) {
    var cartItems = [];
    items.map(function (item) {
        cartItems.push(getEECartProducts(item));
    });
    return cartItems;
};
var getVouchersData = function (orderData) {
    var vouchers = orderData.discounts.vouchers;
    var voucherLength = vouchers.length;
    var vouchersNames = (voucherLength > 0 ? vouchers.map(function (voucherObject) { return voucherObject.voucher; }) : []).join('|');
    var vouchersDiscount = voucherLength > 0 ? vouchers.map(function (voucherObject) { return voucherObject.priceOffAsNumber; })
        .reduce(function (a, b) { return a + b; }, 0) : 0;
    return {
        vouchers: vouchersNames,
        vouchersDiscount: vouchersDiscount
    };
};
// TODO: affiliation
var getPurchaseData = function (orderData) {
    var order = orderData.order, totals = orderData.totals;
    return {
        id: order,
        revenue: "" + totals.grandTotalPriceAsNumber,
        tax: "" + totals.grandTotalPriceTaxAsNumber,
        shipping: "" + totals.shippingPriceAsNumber,
        coupon: getVouchersData(orderData).vouchers,
        couponDiscount: getVouchersData(orderData).vouchersDiscount,
    };
};
var eeAddToCart = function (newStateItems, oldStateItems, currency, mark) {
    var itemsDiff = getCartItemsDiff(newStateItems, oldStateItems || []);
    return addProductToCart(__assign({}, (mark && { origin: mark }), { currencyCode: currency, products: getEECartItems(itemsDiff) }));
};
var eeRemoveFromCart = function (newStateItems, oldStateItems, currency) {
    var itemsDiff = getCartItemsDiff(newStateItems, oldStateItems || []);
    return removeProductFromCart({
        currencyCode: currency,
        products: getEECartItems(itemsDiff),
    });
};
var eeCheckout = function (stateItems, currency) {
    return checkout({
        currencyCode: currency,
        products: getEECartItems(stateItems),
    });
};
var eePurchase = function (orderData) {
    var currency = orderData.currency, items = orderData.items, address = orderData.address;
    return purchase({
        currencyCode: currency,
        actionField: getPurchaseData(orderData),
        products: getEECartItems(items),
        customerData: getEECustomerData(address),
    });
};
var eeCheckoutStep = function (step, option, currency) {
    return checkoutOption({
        currencyCode: currency,
        actionField: {
            step: step.value,
            label: step.label,
            option: option,
        },
    });
};
// ga4
var getValueFromItems = function (items, additionalCosts) {
    var totalValue = items.reduce(function (acc, item) {
        var itemValue = (item.priceEachBeforeDiscountAsNumber - item.priceEachReductionAsNumber) * item.quantity;
        return acc + itemValue;
    }, 0);
    return additionalCosts ? totalValue + additionalCosts : totalValue;
};
// const getGA4Coupon  = (items: IItem[] ): string => {
//   let coupon = '';
//   items.forEach(item => {
//     if (item.anyDiscount) {
//       coupon = 'Discount';
//     }
//   });
//   return coupon;
// };
var getGA4EEProduct = function (productLd, currency, itemListId, itemListName, index) {
    var priceEachBeforeDiscountAsNumber = productLd.priceEachBeforeDiscountAsNumber, priceEachReductionAsNumber = productLd.priceEachReductionAsNumber, priceEachAsNumber = productLd.priceEachAsNumber, quantity = productLd.quantity, productUrl = productLd.productUrl, productIndex = productLd.index;
    var _a = productLd.product, brandName = _a.brandName, sku = _a.sku, centraProduct = _a.centraProduct, centraVariant = _a.centraVariant, name = _a.name, variantName = _a.variantName, categories = _a.categories;
    return __assign({ currency: currency, discount: priceEachReductionAsNumber, fullPrice: priceEachBeforeDiscountAsNumber, index: productIndex || index || 0, item_brand: brandName, item_list_id: itemListId || 'Product Card', item_list_name: itemListName || 'Product Card', item_id: sku }, (centraProduct && { item_centra_product: centraProduct }), (centraVariant && { item_centra_variant: centraVariant }), (window.getContentId && { content_id: window.getContentId(productLd.product) }), { item_name: name, item_variant: variantName || '', price: priceEachAsNumber, url: productUrl || '', quantity: quantity || 1 }, grabCategoriesCollection(categories || []));
};
var getGA4EEProducts = function (items, currency, itemListId, itemListName) {
    var cartItems = [];
    items.map(function (item, index) {
        cartItems.push(getGA4EEProduct(item, currency || '', itemListId, itemListName, index));
    });
    return cartItems;
};
// tslint:disable-next-line
var ga4eeAddToCart = function (newStateItems, oldStateItems, currency, listId, listName) {
    var itemsDiff = getCartItemsDiff(newStateItems, oldStateItems || []).map(function (item) {
        var index = newStateItems.findIndex(function (newItem) { return newItem.sku === item.sku; });
        item.index = index || 0;
        return item;
    });
    return ga4addProductToCart({
        currency: currency,
        items: getGA4EEProducts(itemsDiff, currency, listId, listName),
        value: getValueFromItems(itemsDiff)
    }, {
        event: 'ga4_add_to_cart',
        category: 'item',
        noLabel: true
    });
};
var ga4eeRemoveProductFromCart = function (newStateItems, oldStateItems, currency) {
    var itemsDiff = getCartItemsDiff(newStateItems, oldStateItems || []).map(function (item) {
        var index = oldStateItems && oldStateItems.findIndex(function (oldItem) { return oldItem.sku === item.sku; });
        item.index = index || 0;
        return item;
    });
    return ga4removeProductFromCart({
        currency: currency,
        items: getGA4EEProducts(itemsDiff, currency),
        value: getValueFromItems(itemsDiff)
    }, {
        event: 'ga4_remove_from_cart',
        category: 'item',
        noLabel: true
    });
};
var ga4eeCheckout = function (stateItems, currency, additionalCosts) { return ga4Checkout({
    currency: currency,
    coupon: '',
    items: getGA4EEProducts(stateItems, currency),
    value: getValueFromItems(stateItems, additionalCosts)
}, {
    event: 'ga4_begin_checkout',
    category: 'cart',
    noLabel: true
}); };
var ga4eePurchase = function (orderData) {
    var currency = orderData.currency, items = orderData.items, order = orderData.order, discounts = orderData.discounts, totals = orderData.totals, address = orderData.address;
    return ga4purchase({
        actionField: {
            currency: currency,
            transaction_id: order,
            value: totals.grandTotalPriceAsNumber,
            tax: totals.grandTotalPriceTaxAsNumber,
            shipping: totals.shippingPriceAsNumber,
            coupon: discounts && discounts.vouchers && discounts.vouchers.length > 0 ? discounts.vouchers[0].description : '',
            items: getGA4EEProducts(items, currency),
            userData: {
                email: address.email,
                firstName: address.firstName,
                lastName: address.lastName,
                phone: address.phoneNumber,
                city: address.city,
                state: address.state || '',
                address1: address.address1,
                address2: address.address2,
                zipCode: address.zipCode,
                company: address.company,
                country: address.country || '',
                countryName: address.countryName
            }
        },
    }, {
        event: 'ga4_purchase',
        category: 'cart',
        noLabel: true
    });
};
// FB
var getFBCartProduct = function (item) {
    return {
        id: item.product.sku,
        quantity: item.quantity,
        item_price: item.priceEachAsNumber,
    };
};
var getFBItems = function (items) {
    var cartItems = [];
    items.map(function (item) {
        cartItems.push(getFBCartProduct(item));
    });
    return cartItems;
};
var getFBCartValue = function (items) {
    return items.map(function (item) { return item.totalPriceAsNumber; }).reduce(function (a, b) { return a + b; }, 0);
};
var getFBCartQuantity = function (items) {
    return items.map(function (item) { return item.quantity; }).reduce(function (a, b) { return a + b; }, 0);
};
var fbPageView = function () {
    return track('PageView');
};
var fbViewContent = function (items, currency) {
    return track('ViewContent', {
        content_type: 'product',
        currency: currency,
        value: getFBCartValue(items),
        contents: getFBItems(items),
    });
};
var fbAddToCart = function (newStateItems, oldStateItems, currency) {
    var itemsDiff = getCartItemsDiff(newStateItems, oldStateItems || []);
    return track('AddToCart', {
        content_type: 'product',
        currency: currency,
        value: getFBCartValue(itemsDiff),
        contents: getFBItems(itemsDiff),
    });
};
var fbPurchase = function (orderData) {
    var order = orderData.order, totals = orderData.totals, currency = orderData.currency, items = orderData.items;
    return track('Purchase', {
        order_id: order,
        content_type: 'product',
        currency: currency,
        value: totals.grandTotalPriceAsNumber,
        contents: getFBItems(items),
    });
};
var fbSearch = function (search) {
    return track('Search', {
        search_string: search,
    });
};
var fbCompleteRegistration = function () {
    return track('CompleteRegistration');
};
var fbInitiateCheckout = function (stateItems, currency) {
    return track('InitiateCheckout', {
        content_category: 'shop',
        currency: currency,
        value: getFBCartValue(stateItems),
        contents: getFBItems(stateItems),
        num_items: getFBCartQuantity(stateItems),
    });
};
var fbLead = function () {
    return track('Lead', {});
};
var checkoutAnalytics = {
    getEECartItems: getEECartItems,
    getFBItems: getFBItems,
    getPurchaseData: getPurchaseData,
    getCartItemsDiff: getCartItemsDiff,
    eeAddToCart: eeAddToCart,
    eeRemoveFromCart: eeRemoveFromCart,
    eeCheckout: eeCheckout,
    eeCheckoutStep: eeCheckoutStep,
    eeCheckoutSteps: eeCheckoutSteps,
    eePurchase: eePurchase,
    fbPageView: fbPageView,
    fbViewContent: fbViewContent,
    fbAddToCart: fbAddToCart,
    fbPurchase: fbPurchase,
    fbSearch: fbSearch,
    fbCompleteRegistration: fbCompleteRegistration,
    fbInitiateCheckout: fbInitiateCheckout,
    fbLead: fbLead,
    findifyAddToCart: findifyAddToCart,
    findifyPurchase: findifyPurchase,
    findifyUpdateCart: findifyUpdateCart,
    waitForFindify: waitForFindify,
    getGA4EEProduct: getGA4EEProduct,
    getGA4EEProducts: getGA4EEProducts,
    ga4eeAddToCart: ga4eeAddToCart,
    ga4eeRemoveProductFromCart: ga4eeRemoveProductFromCart,
    ga4eeCheckout: ga4eeCheckout,
    ga4eePurchase: ga4eePurchase
};

var htmlDataAttributes = {
    PRODUCT: 'data-analytics-product',
    CATEGORY: 'data-analytics-category',
    PRODUCT_DETAIL: 'data-analytics-productdetail'
};
// ### track list
var trackGa4ProductList = function (context) {
    var list = getProductList(context);
    return GA4ProductList(list);
};
var trackGa4ProductListAll = function (context) {
    var listAll = getProductListAll(context);
    return listAll.map(function (list) {
        return GA4ProductList(list);
    });
};
var GA4ProductList = function (list) {
    if (!list || !list.itemListElement || list.itemListElement.length === 0) ;
    var productList = getGA4EEProducts$1(list.itemListElement, list.name, list.productListId);
    return ga4ProductList({
        item_list_id: list.productListId || list.name,
        item_list_name: list.name,
        items: productList
    }, {
        event: 'ga4_view_item_list',
        category: 'list',
        noLabel: true
    });
};
// get products list
var getGA4EEProducts$1 = function (items, listName, listId) {
    var cartItems = [];
    items.map(function (item, index) {
        cartItems.push(getGA4EEProduct$1(item, index, listName, listId));
    });
    return cartItems;
};
// get single product
var getGA4EEProduct$1 = function (productLd, listIndex, listName, listId) {
    if (!productLd.ga4) {
        console.log('No ga4 compatible data', listIndex);
    }
    var _a = JSON.parse(productLd.ga4), item_id = _a.item_id, centraProduct = _a.centraProduct, centraVariant = _a.centraVariant, item_name = _a.item_name, currency = _a.currency, discount = _a.discount, index = _a.index, fullPrice = _a.fullPrice, price = _a.price, centraID = _a.centraID, image = _a.image, item_brand = _a.item_brand, item_variant = _a.item_variant, url = _a.url, quantity = _a.quantity;
    return __assign({ currency: currency,
        discount: discount,
        item_brand: item_brand,
        item_id: item_id }, (centraProduct && { item_centra_product: centraProduct }), (centraVariant && { item_centra_variant: centraVariant }), (window.getContentId && { content_id: window.getContentId(JSON.parse(productLd.ga4)) }), { item_name: item_name,
        item_variant: item_variant }, (index !== undefined && { index: index }), (listId && { item_list_id: listId }), (listName && { item_list_name: listName }), { fullPrice: fullPrice,
        price: price,
        centraID: centraID,
        image: image,
        url: url, quantity: quantity || 1 }, grabCategoriesCollection$1(JSON.parse(productLd.ga4)));
};
// ### track product details
var trackGa4Product = function (context) {
    var product = getProduct(context);
    var ga4Items = product && getEEDetailProducts([product]) || [];
    return product
        ? ga4Product({
            currency: JSON.parse(product.ga4).currency,
            items: ga4Items,
            value: ga4Items[0].price // = ga4Items[0].discount ? ga4Items[0].fullPrice - ga4Items[0].discount : ga4Items[0].fullPrice
        }, {
            event: 'ga4_view_item',
            category: 'item',
            noLabel: true
        })
        : emptyPromise$1();
};
var getEEDetailProducts = function (items) {
    var cartItems = [];
    items.map(function (item) {
        var ga4Data = JSON.parse(item.ga4);
        cartItems.push(getGA4EEProduct$1(item, 0, 'Product Card - ' + ga4Data.item_name, ga4Data.url));
    });
    return cartItems;
};
// helper functions
var grabCategoriesCollection$1 = function (productLd) {
    if (!productLd) {
        return {};
    }
    return Object.entries(productLd).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        if (key.startsWith('item_category')) {
            acc[key] = value;
        }
        return acc;
    }, {});
};
var emptyPromise$1 = function () { return Promise.resolve({ error: 'No GA4 markup' }); };
var GA4ProductClick = function (sku, context) {
    var list = getProductList(context);
    if (list && list.itemListElement && list.itemListElement.length > 0) {
        var product = list.itemListElement.find(function (listElement) { return listElement.sku === sku; });
        return product
            ? ga4ProductClick({
                item_list_id: list.productListId,
                item_list_name: list.name,
                items: getGA4EEProducts$1([product], list.name, list.productListId)
            }, {
                event: 'ga4_select_item',
                category: 'item',
                noLabel: true
            })
            : emptyPromise$1();
    }
    return emptyPromise$1();
};
var GA4ProductClickAll = function (sku, context) {
    var listAll = getProductListAll(context);
    var eventTriggered = false;
    listAll.map(function (list) {
        if (!eventTriggered && list && list.itemListElement && list.itemListElement.length > 0) {
            var product = list.itemListElement.find(function (listElement) { return listElement.sku === sku; });
            if (product) {
                eventTriggered = true;
            }
            return product
                ? ga4ProductClick({
                    item_list_id: list.productListId,
                    item_list_name: list.name,
                    items: getGA4EEProducts$1([product], list.name, list.productListId),
                })
                : emptyPromise$1();
        }
        return emptyPromise$1();
    });
    return emptyPromise$1();
};
/* tslint:enable */
var GA4basicConfig = function (config) {
    var productSelector = config && config.productSelector || "[" + htmlDataAttributes.PRODUCT + "]";
    var categorySelector = config && config.categorySelector || "[" + htmlDataAttributes.CATEGORY + "]";
    if (config) {
        var _a = config || {}, _b = _a.storeId, storeId_1 = _b === void 0 ? '1' : _b, _c = _a.contentSuffix, contentSuffix_1 = _c === void 0 ? 's' : _c;
        window.getContentId = function (item) {
            var currentCountryCode = cookies.getItem('countryCode') || 'sv';
            return storeId_1 + "/" + currentCountryCode.toLowerCase() + "-p" + item.centraProduct + "-v" + item.centraVariant + "-" + contentSuffix_1;
        };
    }
    on(productSelector, 'click', function (event) {
        if (event && event.target) {
            // const isLink = event.target.tagName === 'A';
            // const link = isLink ? event.target : event.target.closest('a');
            var isProduct = event.target.dataset && !!event.target.dataset.analyticsProduct;
            var product = isProduct ? event.target : event.target.closest(productSelector);
            var sku = product && product.dataset && product.dataset.analyticsProduct;
            var category = product.closest(categorySelector) || undefined;
            if (sku) {
                GA4ProductClick(sku, category);
            }
        }
    });
};
var ga4HtmlMarkup = {
    trackGa4Product: trackGa4Product,
    trackGa4ProductList: trackGa4ProductList,
    trackGa4ProductListAll: trackGa4ProductListAll,
    GA4ProductClick: GA4ProductClick,
    GA4ProductClickAll: GA4ProductClickAll,
    GA4basicConfig: GA4basicConfig
};

var htmlDataAttributes$1 = {
    PRODUCT: 'data-analytics-product',
    CATEGORY: 'data-analytics-category',
    PRODUCT_DETAIL: 'data-analytics-productdetail'
};
var emptyPromise$2 = function () { return Promise.resolve({ error: 'No markup' }); };
var getFBCartQuantity$1 = function (items) {
    return items
        .map(function (item) { return (item.offers.offers[0].eligibleQuantity ? Number(item.offers.offers[0].eligibleQuantity.value) : 0); })
        .reduce(function (a, b) { return a + b; }, 0);
};
var getEEProduct = function (product, price, list, position) {
    return __assign({ id: product.sku }, (product.centraProduct && { centraProduct: product.centraProduct }), (product.centraVariant && { centraVariant: product.centraVariant }), (window.getContentId && { content_id: window.getContentId(product) }), { fullPrice: product.fullPrice || '', name: product.name, price: price ? price : product.offers.highPrice, priceReduction: product.priceReduction || '', priceTax: product.priceTax || '', brand: product.brand, category: product.category, variant: product.color }, (position && { position: position }), (list && { list: list }));
};
var getEECartProduct$1 = function (product) {
    var offer = product.offers.offers[0];
    return {
        id: product.sku,
        fullPrice: product.fullPrice || '',
        name: product.name,
        price: offer.price,
        priceReduction: product.priceReduction || '',
        priceTax: product.priceTax || '',
        brand: product.brand,
        category: product.category,
        variant: product.color,
        quantity: offer.eligibleQuantity ? offer.eligibleQuantity.value : '1',
    };
};
var getEEDetailProducts$1 = function (items) {
    var cartItems = [];
    items.map(function (item) {
        cartItems.push(getEEProduct(item));
    });
    return cartItems;
};
var getEEDetailProductById = function (items, id) {
    var cartItems = [];
    items.map(function (item) {
        item.offers.offers.map(function (offer) {
            var productID = offer.itemOffered.productID;
            if (productID === id) {
                cartItems.push(getEEProduct(item, offer.price));
            }
        });
    });
    return cartItems;
};
var getEEProducts = function (items, name) {
    var cartItems = [];
    items.map(function (item, index) {
        cartItems.push(getEEProduct(item, undefined, name, index + 1));
    });
    return cartItems;
};
var getEECartProducts$2 = function (items) {
    var cartItems = [];
    items.map(function (item) {
        cartItems.push(getEECartProduct$1(item));
    });
    return cartItems;
};
var getFBCartProduct$1 = function (item) {
    return {
        id: item.sku,
        quantity: item.offers.offers[0].eligibleQuantity ? Number(item.offers.offers[0].eligibleQuantity.value) : 0,
        item_price: Number(item.offers.offers[0].price)
    };
};
var getFBItems$1 = function (items) {
    var cartItems = [];
    items.map(function (item) {
        cartItems.push(getFBCartProduct$1(item));
    });
    return cartItems;
};
var fbViewContent$1 = function (context, idType) {
    var product = getProduct(context);
    var id = idType && idType === 'id' && product ? product.productID : product ? product.sku : '';
    return product
        ? track('ViewContent', {
            content_type: 'product',
            currency: product.offers.offers[0].priceCurrency,
            value: Number(product.offers.highPrice),
            content_ids: [id],
            content_name: product.name
        })
        : emptyPromise$2();
};
var fbViewContentById = function (variantID, idType, context) {
    var product = getProduct(context);
    var id = idType && idType === 'id' && product ? product.productID : product ? product.sku : '';
    var price = '';
    if (product != null) {
        product.offers.offers.map(function (offer) {
            var productID = offer.itemOffered.productID;
            if (productID === variantID) {
                price = offer.price;
            }
        });
    }
    return product && variantID
        ? track('ViewContent', {
            content_type: 'product',
            currency: product.offers.offers[0].priceCurrency,
            value: Number(price),
            content_ids: [id],
            content_name: product.name
        })
        : emptyPromise$2();
};
var fbSearch$1 = function (search) {
    return track('Search', {
        search_string: search
    });
};
var fbLead$1 = function () {
    return track('Lead', {});
};
var fbPurchase$1 = function (context) {
    var receipt = getOrder(context);
    if (receipt) {
        var orderNumber = receipt.orderNumber, acceptedOffer = receipt.acceptedOffer, orderedItem = receipt.orderedItem;
        return track('Purchase', {
            order_id: orderNumber,
            content_type: 'product',
            currency: acceptedOffer.priceCurrency,
            value: Number(acceptedOffer.price),
            contents: getFBItems$1(orderedItem)
        });
    }
    return emptyPromise$2();
};
var eeProductDetailImpressionsById = function (id, context) {
    var product = getProduct(context);
    return product && id
        ? productDetailImpressions({
            currencyCode: product.offers.offers[0].priceCurrency,
            products: getEEDetailProductById([product], id)
        })
        : emptyPromise$2();
};
var eeProductDetailImpressions = function (context) {
    var product = getProduct(context);
    return product
        ? productDetailImpressions({
            currencyCode: product.offers.offers[0].priceCurrency,
            products: getEEDetailProducts$1([product])
        })
        : emptyPromise$2();
};
var eeProductImpressions = function (context) {
    var list = getProductList(context);
    return eeProductImpressionsList(list);
};
var eeProductImpressionsAll = function (context) {
    var listAll = getProductListAll(context);
    listAll.map(function (list) {
        return eeProductImpressionsList(list);
    });
};
var eeProductImpressionsList = function (list) {
    return list && list.itemListElement && list.itemListElement.length > 0
        ? productImpressions({
            currencyCode: list.itemListElement[0].offers.offers[0].priceCurrency,
            impressions: getEEProducts(list.itemListElement, list.name)
        }, {
            noLabel: true
        })
        : emptyPromise$2();
};
var eeProductClick = function (sku, context) {
    var list = getProductList(context);
    if (list && list.itemListElement && list.itemListElement.length > 0) {
        var product = list.itemListElement.find(function (listElement) { return listElement.sku === sku; });
        return product
            ? productClick({
                currencyCode: product.offers.offers[0].priceCurrency,
                products: getEEProducts([product], list.name),
                actionField: {
                    list: list.name
                }
            })
            : emptyPromise$2();
    }
    return emptyPromise$2();
};
var eeProductClickAll = function (sku, context) {
    var listAll = getProductListAll(context);
    var eventTriggered = false;
    listAll.map(function (list) {
        if (!eventTriggered && list && list.itemListElement && list.itemListElement.length > 0) {
            var product = list.itemListElement.find(function (listElement) { return listElement.sku === sku; });
            if (product) {
                eventTriggered = true;
            }
            return product
                ? productClick({
                    currencyCode: product.offers.offers[0].priceCurrency,
                    products: getEEProducts([product], list.name),
                    actionField: {
                        list: list.name
                    }
                })
                : emptyPromise$2();
        }
        return emptyPromise$2();
    });
    return emptyPromise$2();
};
var eePurchase$1 = function (context) {
    var receipt = getOrder(context);
    if (receipt) {
        var orderNumber = receipt.orderNumber, acceptedOffer = receipt.acceptedOffer, orderedItem = receipt.orderedItem, identifier = receipt.identifier, address = receipt.address;
        var tax = identifier && identifier.find(function (item) { return item.name === 'tax'; });
        var shipping = identifier && identifier.find(function (item) { return item.name === 'shipping'; });
        return purchase({
            currencyCode: acceptedOffer.priceCurrency,
            products: getEECartProducts$2(orderedItem),
            actionField: {
                id: orderNumber,
                revenue: acceptedOffer.price,
                tax: tax ? tax.value : '0',
                shipping: shipping ? shipping.value : '0'
            },
            customerData: {
                address1: address.address1,
                address2: address.address2,
                city: address.city,
                country: address.countryName,
                countryCode: address.country,
                email: address.email,
                firstName: address.firstName,
                lastName: address.lastName,
                phone: address.phoneNumber,
                state: address.state,
                zipCode: address.zipCode
            }
        });
    }
    return emptyPromise$2();
};
var fbInitiateCheckout$1 = function (context) {
    var order = getOrder(context);
    if (order) {
        var acceptedOffer = order.acceptedOffer, orderedItem = order.orderedItem;
        return track('InitiateCheckout', {
            content_category: 'shop',
            currency: acceptedOffer.priceCurrency,
            value: Number(acceptedOffer.price),
            contents: getFBItems$1(orderedItem),
            num_items: getFBCartQuantity$1(orderedItem)
        });
    }
    return emptyPromise$2();
};
var eeCheckout$1 = function (context) {
    var order = getOrder(context);
    if (order) {
        var acceptedOffer = order.acceptedOffer, orderedItem = order.orderedItem;
        return checkout({
            currencyCode: acceptedOffer.priceCurrency,
            products: getEECartProducts$2(orderedItem)
        });
    }
    return emptyPromise$2();
};
var basicConfig = function (config) {
    var _a = config || {}, _b = _a.productSelector, productSelector = _b === void 0 ? "[" + htmlDataAttributes$1.PRODUCT + "]" : _b, _c = _a.categorySelector, categorySelector = _c === void 0 ? "[" + htmlDataAttributes$1.CATEGORY + "]" : _c, _d = _a.productDetailSelector, productDetailSelector = _d === void 0 ? "[" + htmlDataAttributes$1.PRODUCT_DETAIL + "]" : _d;
    var productDetail = document.querySelector(productDetailSelector);
    var categories = document.querySelectorAll(categorySelector) || [];
    on(productSelector, 'click', function (event) {
        if (event && event.target) {
            var isLink = event.target.tagName === 'A';
            var link = isLink ? event.target : event.target.closest('a');
            var isProduct = event.target.dataset && !!event.target.dataset.analyticsProduct;
            var product = isProduct ? event.target : event.target.closest(productSelector);
            var href_1 = link && link.href;
            var sku = product && product.dataset && product.dataset.analyticsProduct;
            var category = product.closest(categorySelector) || undefined;
            if (href_1 && sku) {
                eeProductClick(sku, category).then(function () { return (document.location.href = href_1); });
            }
        }
    });
    if (productDetail) {
        eeProductDetailImpressions(productDetail);
        fbViewContent$1(productDetail);
    }
    Array.from(categories).map(function (category) {
        eeProductImpressions(category);
    });
};
var htmlMarkup = {
    fbViewContent: fbViewContent$1,
    fbViewContentById: fbViewContentById,
    fbSearch: fbSearch$1,
    fbLead: fbLead$1,
    fbPurchase: fbPurchase$1,
    fbInitiateCheckout: fbInitiateCheckout$1,
    eeProductDetailImpressions: eeProductDetailImpressions,
    eeProductDetailImpressionsById: eeProductDetailImpressionsById,
    eeProductImpressions: eeProductImpressions,
    eeProductImpressionsAll: eeProductImpressionsAll,
    eeProductClick: eeProductClick,
    eeProductClickAll: eeProductClickAll,
    eePurchase: eePurchase$1,
    eeCheckout: eeCheckout$1,
    basicConfig: basicConfig
};

var nostoCartHtml = function (selection) {
    var oldNostoCart = document.getElementById('nosto_cart');
    if (oldNostoCart !== null && oldNostoCart.parentNode !== null) {
        oldNostoCart.parentNode.removeChild(oldNostoCart);
    }
    var nostoCart$$1 = document.createElement('div');
    nostoCart$$1.setAttribute('id', 'nosto_cart');
    nostoCart$$1.classList.add('nosto_cart');
    nostoCart$$1.setAttribute('style', 'display: none;');
    if (selection) {
        var items = selection.items, currency = selection.currency;
        appendProductsToHTML(nostoCart$$1, items, currency);
    }
    return nostoCart$$1;
};

var nostoProductHtml = function (item, currency) {
    var lineItem = document.createElement('div');
    lineItem.classList.add('line_item');
    var appendedElementsParams = [
        {
            elementToAppendTo: lineItem,
            htmlTag: 'span',
            htmlText: item.product.productSku,
            className: 'product_id',
        },
        {
            elementToAppendTo: lineItem,
            htmlTag: 'span',
            htmlText: item.quantity,
            className: 'quantity',
        },
        {
            elementToAppendTo: lineItem,
            htmlTag: 'span',
            htmlText: item.product.name,
            className: 'name',
        },
        {
            elementToAppendTo: lineItem,
            htmlTag: 'span',
            htmlText: item.product.priceAsNumber,
            className: 'unit_price',
        },
        {
            elementToAppendTo: lineItem,
            htmlTag: 'span',
            htmlText: currency,
            className: 'price_currency_code',
        },
    ];
    if (appendedElementsParams.length > 0) {
        appendedElementsParams.map(function (el) { appendElementToDOM(el); });
    }
    return lineItem;
};

var marketingConsent = cookies.getItem('marketing_consent') === 'true' ? 'true' : 'false';
var nostoPurchaseHtml = function (order) {
    var oldWrapper = document.getElementById('nosto_purchase');
    if (oldWrapper !== null && oldWrapper.parentNode !== null) {
        oldWrapper.parentNode.removeChild(oldWrapper);
    }
    var wrapper = document.createElement('div');
    wrapper.setAttribute('id', 'nosto_purchase');
    if (order) {
        var nostoPurchaseOrder = document.createElement('div');
        var buyer = document.createElement('div');
        var appendedElementsParams = [
            {
                elementToAppendTo: wrapper,
                htmlTag: 'div',
                htmlText: 'order',
                className: 'nosto_page_type',
                styleAttributes: 'display: none;',
            },
            {
                elementToAppendTo: wrapper,
                htmlTag: 'div',
                className: 'nosto_purchase_order',
                styleAttributes: 'display: none;',
                existingHTMLElementToAppend: nostoPurchaseOrder,
            },
            {
                elementToAppendTo: nostoPurchaseOrder,
                htmlTag: 'span',
                htmlText: order.order,
                className: 'order_number',
            },
            {
                elementToAppendTo: nostoPurchaseOrder,
                htmlTag: 'div',
                className: 'buyer',
                existingHTMLElementToAppend: buyer,
            },
            {
                elementToAppendTo: buyer,
                htmlTag: 'span',
                htmlText: order.address.email,
                className: 'email',
            },
            {
                elementToAppendTo: buyer,
                htmlTag: 'span',
                htmlText: order.address.firstName,
                className: 'first_name',
            },
            {
                elementToAppendTo: buyer,
                htmlTag: 'span',
                htmlText: order.address.lastName,
                className: 'last_name',
            },
            {
                elementToAppendTo: buyer,
                htmlTag: 'span',
                htmlText: marketingConsent,
                className: 'marketing_permission',
            },
        ];
        appendedElementsParams.map(function (el) { appendElementToDOM(el); });
        var purchasedItems = document.createElement('div');
        purchasedItems.classList.add('purchased_items');
        var items = order.items, currency = order.currency;
        appendProductsToHTML(purchasedItems, items, currency);
        nostoPurchaseOrder.appendChild(purchasedItems);
    }
    return wrapper;
};

var purchaseTaggingEvent = isBrowser() && new CustomEvent('ysAnalytics/nostoPurchaseTagged', { bubbles: true });
var cartTaggingEvent = isBrowser() && new CustomEvent('ysAnalytics/nostoCartTagged', { bubbles: true });
var body = isBrowser() ? document.querySelector('body') : null;
var appendElementToDOM = function (params) {
    var element;
    if (!params.existingHTMLElementToAppend) {
        element = document.createElement(params.htmlTag);
    }
    else {
        element = params.existingHTMLElementToAppend;
    }
    if (params.className) {
        element.classList.add(params.className);
    }
    if (params.styleAttributes) {
        element.setAttribute('style', params.styleAttributes);
    }
    if (params.htmlText) {
        var text = typeof params.htmlText === 'number' ? params.htmlText.toString(10) : params.htmlText;
        var elementContent = document.createTextNode(text);
        element.appendChild(elementContent);
    }
    params.elementToAppendTo.appendChild(element);
};
var appendProductsToHTML = function (elementToAppendTo, items, currency) {
    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
        var item = items_1[_i];
        if (item) {
            var product = nostoProductHtml(item, currency);
            elementToAppendTo.appendChild(product);
        }
    }
};
var push$2 = function (HTMLelement, DOMelement) { return pushNostoObject(HTMLelement, DOMelement); };
var pushNostoObject = function (HTMLelement, DOMelement) {
    return new Promise(function (resolve) {
        resolve(DOMelement.appendChild(HTMLelement));
    });
};
var nostoPurchase = function (orderData) {
    if (window.nostojs) {
        var purchaseTagging = nostoPurchaseHtml(orderData);
        if (body && purchaseTaggingEvent) {
            return push$2(purchaseTagging, body).then(function () {
                document.dispatchEvent(purchaseTaggingEvent);
            });
        }
    }
    return Promise.resolve();
};
var nostoCart = function (selectionData) {
    if (window.nostojs) {
        var cartTagging = nostoCartHtml(selectionData);
        if (body && cartTaggingEvent) {
            return push$2(cartTagging, body).then(function () {
                document.dispatchEvent(cartTaggingEvent);
            });
        }
    }
    return Promise.resolve();
};
var nosto = {
    nostoPurchase: nostoPurchase,
    nostoCart: nostoCart
};

var dedicated = {
    checkoutApi: checkoutAnalytics,
    findify: findify,
    htmlMarkup: htmlMarkup,
    ga4htmlMarkup: ga4HtmlMarkup,
    nosto: nosto,
};

var rstr2binl = function (input) {
    var output = [];
    output[(input.length >> 2) - 1] = undefined;
    for (var i = 0; i < output.length; i++) {
        output[i] = 0;
    }
    for (var i = 0; i < input.length * 8; i += 8) {
        // @ts-ignore
        output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << i % 32;
    }
    // @ts-ignore
    return output;
};
var safeAdd = function (x, y) {
    var lsw = (x & 0xffff) + (y & 0xffff);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return (msw << 16) | (lsw & 0xffff);
};
var bitRotateLeft = function (num, cnt) { return (num << cnt) | (num >>> (32 - cnt)); };
var md5cmn = function (q, a, b, x, s, t) {
    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
};
var md5ff = function (a, b, c, d, x, s, t) { return md5cmn((b & c) | (~b & d), a, b, x, s, t); };
var md5gg = function (a, b, c, d, x, s, t) { return md5cmn((b & d) | (c & ~d), a, b, x, s, t); };
var md5hh = function (a, b, c, d, x, s, t) { return md5cmn(b ^ c ^ d, a, b, x, s, t); };
var md5ii = function (a, b, c, d, x, s, t) { return md5cmn(c ^ (b | ~d), a, b, x, s, t); };
var binlMD5 = function (x, len) {
    // append padding
    x[len >> 5] |= 0x80 << len % 32;
    x[(((len + 64) >>> 9) << 4) + 14] = len;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;
    var originA = a;
    var originB = b;
    var originC = c;
    var originD = d;
    for (var i = 0; i < x.length; i += 16) {
        // First cycle
        a = md5ff(a, b, c, d, x[i], 7, -680876936);
        d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
        b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
        // Second cycle
        a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = md5gg(b, c, d, a, x[i], 20, -373897302);
        a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
        // Third cycle
        a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
        d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = md5hh(d, a, b, c, x[i], 11, -358537222);
        c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
        // Fourth cycle
        a = md5ii(a, b, c, d, x[i], 6, -198630844);
        d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
        // Last cycle
        a = safeAdd(a, originA);
        b = safeAdd(b, originB);
        c = safeAdd(c, originC);
        d = safeAdd(d, originD);
    }
    return [a, b, c, d];
};
var binl2rstr = function (input) {
    var output = '';
    var length32 = input.length * 32;
    for (var i = 0; i < length32; i += 8) {
        output += String.fromCharCode((input[i >> 5] >>> i % 32) & 0xff);
    }
    return output;
};
var rawStringToHex = function (input) {
    var hexTab = '0123456789abcdef';
    var output = '';
    for (var i = 0; i < input.length; i += 1) {
        var x = input.charCodeAt(i);
        output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f);
    }
    return output;
};
var md5 = function (value) {
    var stringUTF8 = unescape(encodeURIComponent(value));
    var stringNumArr = rstr2binl(stringUTF8);
    var binlMD5Arr = binlMD5(stringNumArr, stringUTF8.length * 8);
    var rawString = binl2rstr(binlMD5Arr);
    return rawStringToHex(rawString);
};

var utf8Encode = function (str) {
    try {
        return new TextEncoder().encode(str).reduce(function (prev, curr) { return prev + String.fromCharCode(curr); }, '');
    }
    catch (e) {
        // no TextEncoder available?
        return unescape(encodeURIComponent(str)); // monsur.hossa.in/2012/07/20/utf-8-in-javascript.html
    }
};
var hexBytesToString = function (hexStr) {
    // convert string of hex numbers to a string of chars (eg '616263' -> 'abc').
    var str = hexStr.replace(' ', ''); // allow space-separated groups
    if (str === '') {
        return '';
    }
    var stringMatch = str.match(/.{2}/g);
    return stringMatch ? stringMatch.map(function (byte) { return String.fromCharCode(parseInt(byte, 16)); }).join('') : '';
};
var ROTR = function (n, x) { return (x >>> n) | (x << (32 - n)); };
var Σ0 = function (x) { return ROTR(2, x) ^ ROTR(13, x) ^ ROTR(22, x); };
var Σ1 = function (x) { return ROTR(6, x) ^ ROTR(11, x) ^ ROTR(25, x); };
var σ0 = function (x) { return ROTR(7, x) ^ ROTR(18, x) ^ (x >>> 3); };
var σ1 = function (x) { return ROTR(17, x) ^ ROTR(19, x) ^ (x >>> 10); };
var Ch = function (x, y, z) { return (x & y) ^ (~x & z); };
var Maj = function (x, y, z) { return (x & y) ^ (x & z) ^ (y & z); };
var sha256 = function (msg, options) {
    var defaults = {
        msgFormat: 'string',
        outFormat: 'hex',
    };
    var opt = Object.assign(defaults, options || {});
    switch (opt.msgFormat) {
        case 'hex-bytes':
            msg = hexBytesToString(msg);
            break; // mostly for running tests
        case 'string':
        default: // default is to convert string to UTF-8, as SHA only deals with byte-streams
            msg = utf8Encode(msg);
            break;
    }
    // constants [§4.2.2]
    var K = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2,
    ];
    // initial hash value [§5.3.3]
    var H = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19,
    ];
    // PREPROCESSING [§6.2.1]
    msg += String.fromCharCode(0x80); // add trailing '1' bit (+ 0's padding) to string [§5.1.1]
    // convert string msg into 512-bit blocks (array of 16 32-bit integers) [§5.2.1]
    var l = msg.length / 4 + 2; // length (in 32-bit integers) of msg + ‘1’ + appended length
    var N = Math.ceil(l / 16); // number of 16-integer (512-bit) blocks required to hold 'l' ints
    var M = new Array(N); // message M is N×16 array of 32-bit integers
    for (var i = 0; i < N; i++) {
        M[i] = new Array(16);
        for (var j = 0; j < 16; j++) {
            // encode 4 chars per integer (64 per block), big-endian encoding
            M[i][j] =
                (msg.charCodeAt(i * 64 + j * 4 + 0) << 24) |
                    (msg.charCodeAt(i * 64 + j * 4 + 1) << 16) |
                    (msg.charCodeAt(i * 64 + j * 4 + 2) << 8) |
                    (msg.charCodeAt(i * 64 + j * 4 + 3) << 0);
        } // note running off the end of msg is ok 'cos bitwise ops on NaN return 0
    }
    // add length (in bits) into final pair of 32-bit integers (big-endian) [§5.1.1]
    // note: most significant word would be (len-1)*8 >>> 32, but since JS converts
    // bitwise-op args to 32 bits, we need to simulate this by arithmetic operators
    var lenHi = ((msg.length - 1) * 8) / Math.pow(2, 32);
    var lenLo = ((msg.length - 1) * 8) >>> 0;
    M[N - 1][14] = Math.floor(lenHi);
    M[N - 1][15] = lenLo;
    // HASH COMPUTATION [§6.2.2]
    for (var i = 0; i < N; i++) {
        var W = new Array(64);
        // 1 - prepare message schedule 'W'
        for (var t = 0; t < 16; t++) {
            W[t] = M[i][t];
        }
        for (var t = 16; t < 64; t++) {
            W[t] = (σ1(W[t - 2]) + W[t - 7] + σ0(W[t - 15]) + W[t - 16]) >>> 0;
        }
        // 2 - initialise working variables a, b, c, d, e, f, g, h with previous hash value
        var a = H[0];
        var b = H[1];
        var c = H[2];
        var d = H[3];
        var e = H[4];
        var f = H[5];
        var g = H[6];
        var h = H[7];
        // 3 - main loop (note '>>> 0' for 'addition modulo 2^32')
        for (var t = 0; t < 64; t++) {
            var T1 = h + Σ1(e) + Ch(e, f, g) + K[t] + W[t];
            var T2 = Σ0(a) + Maj(a, b, c);
            h = g;
            g = f;
            f = e;
            e = (d + T1) >>> 0;
            d = c;
            c = b;
            b = a;
            a = (T1 + T2) >>> 0;
        }
        // 4 - compute the new intermediate hash value (note '>>> 0' for 'addition modulo 2^32')
        H[0] = (H[0] + a) >>> 0;
        H[1] = (H[1] + b) >>> 0;
        H[2] = (H[2] + c) >>> 0;
        H[3] = (H[3] + d) >>> 0;
        H[4] = (H[4] + e) >>> 0;
        H[5] = (H[5] + f) >>> 0;
        H[6] = (H[6] + g) >>> 0;
        H[7] = (H[7] + h) >>> 0;
    }
    var newH = [];
    // convert H0..H7 to hex strings (with leading zeros)
    for (var h = 0; h < H.length; h++) {
        newH[h] = ('00000000' + H[h].toString(16)).slice(-8);
    }
    // concatenate H0..H7, with separator if required
    var separator = opt.outFormat === 'hex-w' ? ' ' : '';
    return newH.join(separator);
};

var hashes = {
    md5: md5,
    sha256: sha256,
};

var ysAnalytics = {
    cookies: cookies,
    dataLayer: dataLayer,
    dedicated: dedicated,
    dom: dom,
    ecommerce: ecommerce,
    events: events,
    facebook: facebook,
    gtm: gtm,
    hashes: hashes,
    storage: storage,
};

export default ysAnalytics;
export { checkoutAnalytics as checkoutApi, cookies, dataLayer, dedicated, dom, ecommerce, events, facebook, gtm, htmlMarkup, ga4HtmlMarkup as ga4htmlMarkup, nosto, storage };
//# sourceMappingURL=ys-analytics.esm.js.map
